import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { createYupSchema } from "../../utilities/yupSchemaCreator";
import {
  CompanyFormFields,
  RechargedFormFields,
  SiteFormFields,
} from "./Fields";
import styled from "styled-components";
import {
  Alert,
  Box,
  Button,
  Card,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  MenuItem,
  OutlinedInput,
  Select,
  Switch,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import ErrorsList from "../../ui/ErrorsList";
import { useNavigate } from "react-router-dom";
import { useSite } from "../Sites/Provider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import "dayjs/locale/de";
import "dayjs/locale/en-gb";
import { useCompany } from "../Companies/Provider";
import { PaymentTypeForm, PlanEnum } from "../../utilities/Enum";
import { useMember } from "./provider";
import { CalDate } from "../../utilities/functions";
import { useAuth } from "../../services/auth";
import AddMoreRows from "../../ui/AddMoreRows";

const yupSchema = CompanyFormFields.reduce(createYupSchema, {});
const formSchema = Yup.object().shape(yupSchema);

const ButtonWrapper = styled.div`
  margin-bottom: 50px;
  button {
    float: right;
    margin-left: 20px;
  }
`;
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const FormMember = ({ member, handleSuccess }) => {
  const { role, adminOn } = useAuth();

  let theme = useTheme();
  let navigate = useNavigate();
  const [startDate, setStartDate] = useState(
    member?.startDate ? dayjs(member?.startDate) : null,
  );

  const [error, setError] = useState();
  const [rows, setRows] = useState(
    Array(1)
      .fill(0)
      .map(() => ({ siteId: "", serviceIds: [] })),
  );

  useEffect(() => {
    if (!member?.services?.length) return;

    const rows = member.services.map((service) => ({
      siteId: service.id,
      serviceIds: service.servises,
    }));

    setRows(rows);
  }, [member]);

  const [planId, setPlanId] = useState(1);
  const [locale] = useState("en-gb");

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
  });
  const {
    state: { Names: sites, selected: site },
    fetchSiteNames: fetchSites,
  } = useSite();
  const {
    state: { Names: companies },
    fetchNames: fetchCompany,
  } = useCompany();

  const {
    state: { companyIdAtt, memberQRField },
    dispatch,
    create,
    edit,
  } = useMember();

  useEffect(() => {
    if (member?.sites) {
      setValue(
        "siteIds",
        member?.services?.map((site) => site.id),
      );
      setValue(
        "serviceIds",
        member?.services?.flatMap(
          (site) => site?.servises?.map((service) => service.id) || [],
        ),
      );
    }
  }, [member]);
  useEffect(() => {
    if (role === "Admin") fetchCompany();
  }, [fetchCompany, role]);
  useEffect(() => {
    if (member) setPlanId(member?.planId);
  }, [member]);
  useEffect(() => {
    if (role === "Admin" && companyIdAtt) fetchSites(companyIdAtt, 0);
  }, [companyIdAtt, role]);
  useEffect(() => {
    if (role === "Company") fetchSites(adminOn?.id, 0);
  }, [role, adminOn]);

  useEffect(() => {
    if (role === "Company") setValue("companyId", adminOn.id);
  }, [role, adminOn]);
  useEffect(() => {
    if (role === "Site") setValue("companyId", site.company.id);
  }, [role, site]);

  useEffect(() => {
    dispatch({ type: "set_companyIdAtt", payload: member?.company?.id });
  }, [member]);
  useEffect(() => {
    if (role === "Site") setValue("siteIds", [adminOn.id]);
  }, [role, adminOn]);
  useEffect(() => {
    if (member?.sites) {
      setValue(
        "siteIds",
        member?.sites?.map((s) => s.id),
      );
    }
  }, [member]);
  useEffect(() => {
    if (member?.expireDate) {
      setValue("expireDate", CalDate(member?.expireDate));
    }
  }, [member]);
  useEffect(() => {
    if (member?.startDate) {
      setValue("startDate", CalDate(member?.startDate));
    }
  }, [member]);
  const [SItesMulti, setSItesMulti] = useState(
    member ? member?.sites?.map((s) => s.id) : [] || [],
  );
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    const selectedIds =
      typeof value === "string" ? value.split(",").map(Number) : value;
    setSItesMulti(selectedIds);
    setValue("siteIds", value);
  console.log(value,"vv")
  };

  const getData = (name) => {
    const dataMap = {
      companyId: [
        ...(companies?.map(({ id, name }) => ({
          id: id,
          name: name,
        })) || []),
      ],
      planId: [
        ...(PlanEnum?.map(({ id, name }) => ({
          id: id,
          name: name,
        })) || []),
      ],
      paymentTypeId: [
        ...(PaymentTypeForm?.map(({ id, name }) => ({
          id: id,
          name: name,
        })) || []),
      ],
      siteIds: [
        ...(sites?.map(({ id, name }) => ({
          id: id,
          name: name,
        })) || []),
      ],
    };

    return dataMap[name] || [];
  };
  useEffect(() => {
    if (member?.sites) {
      const ids = member?.sites?.map((site) => site.id);
      setValue("siteIds", ids);
    }
  }, [member]);
  
  const onSubmit = async (values) => {
    if (values.paymentTypeId === 0 && values.amount > 0) {
      setError({
        title: "Amount should be 0 or change payment type",
      });
    } else {
      try {
        const payload = {
          ...values,
          printingInfo: JSON.stringify(memberQRField || {}),
        };
        if (member) {
          await edit(payload, member?.id);
        } else {
          await create(payload);
        }
        handleSuccess();
      } catch (error) {
        window.scroll(0, 0);
        setError({
          title: error?.errors?.message
            ? error.errors.message
            : error?.response?.data?.message || "some thing wrong",
        });
      }
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      {error ? (
        <Alert severity="error" sx={{ my: 3 }}>
          <ErrorsList error={error} />
        </Alert>
      ) : (
        ""
      )}
      <Card
        sx={{
          p: theme.dimensions.padding,
          mt: theme.dimensions.mt,
          mb: theme.dimensions.mb,
        }}
      >
        <Typography variant="Poster" mb={3} component="h4" gutterBottom>
          Member Details
        </Typography>
        <Grid container spacing={2} sx={{ width: "80%" }}>
          <Grid item xs={12} md={6}>
            <FormControl
              sx={{
                width: theme.dimensions.width,
              }}
              error={!!errors["planId"]}
            >
              <span style={{ fontSize: "12px" }}>{"Plan"}</span>

              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                inputProps={{
                  ...register("planId"),
                  required: true,
                }}
                defaultValue={member?.planId || planId}
                size="small"
                onChange={(e) => {
                  setPlanId(e.target.value);
                }}
              >
                {getData("planId")?.map((item, index) => (
                  <MenuItem key={index} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            {role === "Admin" ? (
              <FormControl
                sx={{
                  width: theme.dimensions.width,
                }}
                error={!!errors["companyId"]}
              >
                <span style={{ fontSize: "12px" }}>{"Company"}</span>

                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  inputProps={{
                    ...register("companyId"),
                    required: true,
                  }}
                  defaultValue={member ? member?.company?.id : companyIdAtt}
                  size="small"
                  onChange={(e) => {
                    dispatch({
                      type: "set_companyIdAtt",
                      payload: e.target.value,
                    });
                  }}
                >
                  {getData("companyId")?.map((item, index) => (
                    <MenuItem key={index} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : (
              <Box>
                <span style={{ fontSize: "12px" }}>Company Name</span>
                {role === "Company" && (
                  <Box
                    sx={{
                      borderBottom: "1px solid gray",
                      width: "290px",
                      borderRadius: "8px",
                      textAlign: "center",
                      marginRight: "20px",
                      marginTop: "15px",
                    }}
                  >
                    {adminOn?.companyName}
                  </Box>
                )}
                {role === "Site" && (
                  <Box
                    sx={{
                      borderBottom: "1px solid gray",
                      width: "290px",
                      borderRadius: "8px",
                      textAlign: "center",
                      marginRight: "20px",
                      marginTop: "15px",
                    }}
                  >
                    {site?.company?.companyName}
                  </Box>
                )}
              </Box>
            )}
          </Grid>
        </Grid>
        {planId === 1 && (
          <Grid container spacing={2} sx={{ width: "80%" }}>
            {CompanyFormFields.map((f, index) => (
              <Grid item xs={12} md={6} key={index}>
                {f.input && (
                  <FormControl
                    sx={{
                      width: theme.dimensions.width,
                      mt: theme.dimensions.mt,
                      mb: theme.dimensions.mb,
                    }}
                  >
                    <span style={{ fontSize: "12px" }}>{f.label}</span>
                    <TextField
                      name={f.name}
                      error={!!errors[f.name]}
                      helperText={errors[f.name]?.message}
                      type={f.type}
                      defaultValue={f.name === "amount" ? 0 : member?.[f.name]}
                      fullWidth
                      disabled={f.disabled}
                      required={f.required}
                      sx={{
                        width: theme.dimensions.width,
                      }}
                      inputProps={{
                        ...register(f?.name),
                        required: f.required,
                      }}
                      size="small"
                    />
                    {f.name === "amount" && (
                      <p style={{ color: "grey" }}>
                        <em>Balance: {member?.balance}</em>
                      </p>
                    )}
                  </FormControl>
                )}
                {f.select && (
                  <FormControl
                    sx={{
                      width: theme.dimensions.width,
                    }}
                    error={!!errors[f.name]}
                  >
                    <span style={{ fontSize: "12px" }}>{f.label}</span>

                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      inputProps={{
                        ...register(f?.name),
                        required: true,
                      }}
                      defaultValue={
                        f.name === "paymentTypeId" ? 0 : member?.[f.name]
                      }
                      size="small"
                    >
                      {getData(f.name)?.map((item, index) => (
                        <MenuItem key={index} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
                {f.multiSelect && (
                  <>
                    {role === "Site" ? (
                      <Box>
                        <span style={{ fontSize: "12px" }}>Site Name</span>
                        <Box
                          sx={{
                            borderBottom: "1px solid gray",
                            width: "290px",
                            borderRadius: "8px",
                            textAlign: "center",
                            marginRight: "20px",
                            marginTop: "15px",
                          }}
                        >
                          {adminOn?.siteName}
                        </Box>
                      </Box>
                    ) : (
                      <FormControl
                        sx={{
                          width: theme.dimensions.width,
                        }}
                        error={!!errors[f.name]}
                        size="small"
                      >
                        <span style={{ fontSize: "12px" }}>Sites</span>
                        <Select
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          multiple
                          value={SItesMulti}
                          onChange={handleChange}
                          input={<OutlinedInput label="Site" />}
                          MenuProps={MenuProps}
                        >
                          {sites.map((site) => (
                            <MenuItem key={site.id} value={site.id}>
                              {site.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </>
                )}
                {f.date && (
                  <LocalizationProvider
                    key={f.name}
                    dateAdapter={AdapterDayjs}
                    adapterLocale={locale}
                  >
                    <div components={["DateRangePicker"]}>
                      <DatePicker
                        label={f.label}
                        onChange={(date) => {
                          setValue(f.name, CalDate(date));
                          if (f.name === "startDate") setStartDate(date);
                        }}
                        defaultValue={member && dayjs(member?.[f.name])}
                        minDate={
                          f.name === "expireDate" && startDate
                            ? startDate
                            : undefined
                        }
                        slotProps={{
                          textField: {
                            required: f.required,
                            error: errors[f.name]?.message,
                            helperText: (
                              <p style={{ color: "#d32f2f" }}>
                                {errors[f.name]?.message}
                              </p>
                            ),
                            size: "small",
                          },
                        }}
                        sx={{ mt: 2, width: "300px" }}
                      />
                    </div>
                  </LocalizationProvider>
                )}
              </Grid>
            ))}
          </Grid>
        )}
        {planId === 2 && (
          <Grid container spacing={2} sx={{ width: "80%" }}>
            {SiteFormFields.map((f, index) => (
              <Grid item xs={12} md={6} key={index}>
                {f.input && (
                  <FormControl
                    sx={{
                      width: theme.dimensions.width,
                      mt: theme.dimensions.mt,
                      mb: theme.dimensions.mb,
                    }}
                  >
                    <span style={{ fontSize: "12px" }}>{f.label}</span>
                    <TextField
                      name={f.name}
                      error={!!errors[f.name]}
                      helperText={errors[f.name]?.message}
                      type={f.type}
                      fullWidth
                      disabled={f.disabled}
                      required={f.required}
                      defaultValue={f.type === "number" ? 0 : member?.[f.name]}
                      sx={{
                        width: theme.dimensions.width,
                      }}
                      inputProps={{
                        ...register(f?.name),
                        required: f.required,
                      }}
                      size="small"
                    />
                    {f.name === "amount" && (
                      <p style={{ color: "grey" }}>
                        <em>Balance: {member?.balance}</em>
                      </p>
                    )}
                  </FormControl>
                )}
                {f.select && (
                  <>
                    {role === "Site" && f.name === "siteIds" ? (
                      <Box>
                        <span style={{ fontSize: "12px" }}>Site Name</span>
                        <Box
                          sx={{
                            borderBottom: "1px solid gray",
                            width: "290px",
                            borderRadius: "8px",
                            textAlign: "center",
                            marginRight: "20px",
                            marginTop: "15px",
                          }}
                        >
                          {adminOn?.siteName}
                        </Box>
                      </Box>
                    ) : (
                      <FormControl
                        sx={{
                          width: theme.dimensions.width,
                        }}
                        error={!!errors[f.name]}
                      >
                        <span style={{ fontSize: "12px" }}>{f.label}</span>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          onChange={(e) => {
                            if (f.name === "siteIds") {
                              setValue("siteIds", [e.target.value]);
                            }
                          }}
                          inputProps={
                            f.name !== "siteIds" && {
                              ...register(f?.name),
                              required: true,
                            }
                          }
                          defaultValue={
                            f.name === "siteIds"
                              ? member?.sites[0]?.id
                              : f.name === "paymentTypeId"
                                ? 0
                                : member?.[f.name]
                          }
                          size="small"
                        >
                          {getData(f.name)?.map((item, index) => (
                            <MenuItem key={index} value={item.id}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </>
                )}

                {f.date && (
                  <LocalizationProvider
                    key={f.name}
                    dateAdapter={AdapterDayjs}
                    adapterLocale={locale}
                  >
                    <div components={["DateRangePicker"]}>
                      <DatePicker
                        label={f.label}
                        onChange={(date) => {
                          setValue(f.name, CalDate(date));
                          if (f.name === "startDate") setStartDate(date);
                        }}
                        defaultValue={member && dayjs(member?.[f.name])}
                        minDate={
                          f.name === "expireDate" && startDate
                            ? startDate
                            : undefined
                        }
                        error={!!errors[f.name]}
                        slotProps={{
                          textField: {
                            required: f.required,
                            error: errors[f.name]?.message,
                            helperText: (
                              <p style={{ color: "#d32f2f" }}>
                                {errors[f.name]?.message}
                              </p>
                            ),
                            size: "small",
                          },
                        }}
                        sx={{ mt: 2, width: "300px" }}
                      />
                    </div>
                  </LocalizationProvider>
                )}
              </Grid>
            ))}
          </Grid>
        )}
        {planId === 3 && (
          <Grid container spacing={2} sx={{ width: "80%" }}>
            <Box sx={{ margin: "25px 15px" }}>
              <AddMoreRows
                props={{
                  rows: rows,
                  setRows: setRows,
                  Lists: [sites],
                  Labels: ["Site", "Services"],

                  text: "+ Add more site",
                  setValue: setValue,
                  role: role,
                  adminOn: adminOn,
                }}
              />
            </Box>
            {RechargedFormFields.map((f, index) => (
              <Grid item xs={12} md={6} key={index}>
                {f.select && (
                  <FormControl
                    sx={{
                      width: theme.dimensions.width,
                    }}
                    error={!!errors[f.name]}
                  >
                    <span style={{ fontSize: "12px" }}>{f.label}</span>

                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      inputProps={{
                        ...register(f?.name),
                        required: true,
                      }}
                      defaultValue={
                        f.name === "companyId" && member
                          ? member?.company?.id
                          : f.name === "paymentTypeId"
                            ? 0
                            : member?.[f.name] || companyIdAtt
                      }
                      size="small"
                      onChange={(e) => {
                        if (f.name === "planId") {
                          setPlanId(e.target.value);
                        } else if (f.name === "companyId") {
                          dispatch({
                            type: "set_companyIdAtt",
                            payload: e.target.value,
                          });
                        }
                      }}
                    >
                      {getData(f.name)?.map((item, index) => (
                        <MenuItem key={index} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
                {f.input && (
                  <FormControl
                    sx={{
                      width: theme.dimensions.width,
                      mt: theme.dimensions.mt,
                      mb: theme.dimensions.mb,
                    }}
                  >
                    <span style={{ fontSize: "12px" }}>{f.label}</span>
                    <TextField
                      name={f.name}
                      error={!!errors[f.name]}
                      helperText={errors[f.name]?.message}
                      type={f.type}
                      fullWidth
                      disabled={f.disabled}
                      required={f.required}
                      defaultValue={f.type === "number" ? 0 : member?.[f.name]}
                      sx={{
                        width: theme.dimensions.width,
                      }}
                      inputProps={{
                        ...register(f?.name),
                        required: f.required,
                      }}
                      size="small"
                    />
                    {f.name === "amount" && (
                      <p style={{ color: "grey" }}>
                        <em>Balance: {member?.balance}</em>
                      </p>
                    )}
                  </FormControl>
                )}
              </Grid>
            ))}
          </Grid>
        )}
        <Grid container spacing={2} sx={{ width: "80%" }}>
          <Grid item xs={12} md={6}>
            <FormControl
              sx={{
                width: theme.dimensions.width,
                mt: theme.dimensions.mt,
                mb: theme.dimensions.mb,
              }}
            >
              <span style={{ fontSize: "12px" }}>Times per Days</span>
              <TextField
                name={"timesPerDay"}
                error={!!errors["timesPerDay"]}
                helperText={errors["timesPerDay"]?.message}
                type={"number"}
                fullWidth
                defaultValue={member ? member?.timesPerDay : 0}
                sx={{ width: theme.dimensions.width }}
                inputProps={{ ...register("timesPerDay") }}
                size="small"
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormGroup>
              <FormLabel component="legend" sx={{ mt: theme.dimensions.mt }}>
                {"Status"}
              </FormLabel>
              <FormControlLabel
                sx={{ mt: theme.dimensions.mt }}
                control={
                  <Switch
                    color="success"
                    defaultChecked={member ? member?.isActive : true}
                  />
                }
                {...register("isActive")}
                label="Active"
              />
            </FormGroup>
          </Grid>
        </Grid>
      </Card>
      <ButtonWrapper>
        <Button
          variant="contained"
          type="submit"
          sx={{
            backgroundColor: theme.color.blackBackground,
            ml: theme.dimensions.ml,
            "&:hover": { background: `${theme.color.black}` },
          }}
        >
          {member ? "Save" : " Add Member"}
        </Button>
        <Button
          variant="contained"
          onClick={() => navigate(-1)}
          sx={{
            backgroundColor: theme.color.grayBackground,
            color: theme.color.dark,
            "&:hover": { background: `${theme.color.gray50}` },
          }}
        >
          Discard
        </Button>
      </ButtonWrapper>
    </form>
  );
};

export default FormMember;
